import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';

type IColProps = PropsWithChildren<{
  className?: string;
  wrap?: boolean;
  span?: number;
  offset?: number;
  auto?: boolean;
}>;

const Col: FC<IColProps> = ({ children, className = '', wrap = false, auto = false, span = 0, offset = 0 }) => {
  const rootClass = classNames('ink-col', className, {
    [`ink-col-${span}`]: span > 0,
    [`ink-col__offset-${offset}`]: offset > 0,
    'ink-col--wrap': wrap,
    'ink-col--auto': auto,
  });
  return <View className={rootClass}>{children}</View>;
};

export default Col;
